export const reduxKey = '@@gruser';
